<template>
  <div id="app">

    <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light center">
      <!-- <router-link class="navbar-brand" to="/">Chov oviec Clun Forest</router-link> -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar-nav mx-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">Úvod</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/blog">Ovčí život</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/about">O nás</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/clun_forest">Clun Forest</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/breeding_year">Chovateľský rok</router-link>
          </li>
          <!--
          <li class="nav-item">
            <router-link class="nav-link disabled" to="">Galéria</router-link>
          </li>
          -->
        </ul>
      </div>
    </nav>

    <router-view name="banner"></router-view>
    <router-view name="content"></router-view>
    <Footer/>
  </div>
</template>

<script>
  import Footer from '@/components/Footer'

  export default {
      name: 'App',
      components: { Footer },
  }
</script>

<style>
  #app {
    text-align: center;
    color: #333;
  }
  nav.navbar {
    background-color: transparent !important;
    padding: 20px;
    -webkit-transition: all 0.3s linear;
    transition: all 0.3s linear;
  }
  nav.navbar::before {
    content:""; 
    position: absolute;
    background: none;
    bottom: 0;
    left: 10%;
    height: 1px;
    width: 80%;
    background-color: #777;
    -webkit-transition: all 0.3s linear;
    transition: all 0.3s linear;
  }
  nav.navbar.scrolled {
    background-color: rgba(255, 255, 255, 0.9) !important;
    padding: 2px;
  }
  nav.navbar.scrolled::before {
    left: 0;
    width: 100%;
    background-color: #ccc;
  }
  .navbar-light .navbar-nav .nav-link {
    color: #000;
    margin: 0 25px;
    font-size: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue